var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 8.00016C3.33337 4.46683 8.33337 3.66683 10.6667 4.66683C10.8 4.26683 11.6667 3.3335 12.6667 3.3335V5.3335C13 5.66683 13.3334 6.00016 13.3334 6.66683H14.6667V9.3335H13.3334C13.1334 10.0002 12.6667 10.3335 12 10.6668V13.3335H9.33337V12.0002H7.33337V13.3335H4.66671V11.0002C3.33337 10.0002 3.33337 9.20016 3.33337 8.00016ZM3.33337 8.00016H2.66671C1.93337 8.00016 1.33337 7.40016 1.33337 6.66683V6.00016M10.6667 7.3335H10.6734",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggy-bank.a75dc2e1261309d98cf01a1179dc83e7.svg";
export { ForwardRef as ReactComponent };